export const bolderFont = (text: string) => {
  return `<b>${text}</b>`;
};
